export const UI_SETTINGS = {
    PAGE_LAYOUT_CONTAINER: {
        ID: 'page-layout-container',
    },
} as const;
